var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3413_2887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 0.5H2.16667C0.97175 0.5 0 1.47175 0 2.66667V3.20833C0 3.68825 0.209625 4.1205 0.541667 4.41842V10.7917C0.541667 12.285 1.75662 13.5 3.25 13.5H4.875C5.174 13.5 5.41667 13.2573 5.41667 12.9583C5.41667 12.6593 5.174 12.4167 4.875 12.4167H3.25C2.35408 12.4167 1.625 11.6876 1.625 10.7917V4.83333H11.375V5.375C11.375 5.674 11.6177 5.91667 11.9167 5.91667C12.2157 5.91667 12.4583 5.674 12.4583 5.375V4.41842C12.7904 4.1205 13 3.68879 13 3.20833V2.66667C13 1.47175 12.0283 0.5 10.8333 0.5ZM1.625 3.75C1.32654 3.75 1.08333 3.50679 1.08333 3.20833V2.66667C1.08333 2.06921 1.56921 1.58333 2.16667 1.58333H10.8333C11.4308 1.58333 11.9167 2.06921 11.9167 2.66667V3.20833C11.9167 3.50679 11.6735 3.75 11.375 3.75H1.625ZM9.20833 5.91667C7.1175 5.91667 5.41667 7.6175 5.41667 9.70833C5.41667 11.7992 7.1175 13.5 9.20833 13.5C11.2992 13.5 13 11.7992 13 9.70833C13 7.6175 11.2992 5.91667 9.20833 5.91667ZM9.20833 12.4167C7.71496 12.4167 6.5 11.2017 6.5 9.70833C6.5 8.21496 7.71496 7 9.20833 7C10.7017 7 11.9167 8.21496 11.9167 9.70833C11.9167 11.2017 10.7017 12.4167 9.20833 12.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5C10.2761 10.5 10.5 10.2761 10.5 10C10.5 9.72386 10.2761 9.5 10 9.5H9.5H8.5H8C7.72386 9.5 7.5 9.72386 7.5 10C7.5 10.2761 7.72386 10.5 8 10.5H8.5V11C8.5 11.2761 8.72386 11.5 9 11.5C9.27614 11.5 9.5 11.2761 9.5 11V10.5H10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5C8.72386 8.5 8.5 8.72386 8.5 9V9.5H9.5V9C9.5 8.72386 9.27614 8.5 9 8.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3413_2887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.849d10e19f6643e15079979d857b10ca.svg";
export { ForwardRef as ReactComponent };